import context, { IAppUserContext, AsyncComponentLoading, AsyncComponentError } from '@truckdown/components-systems';
import { Constants, IInitializer, IUserContext } from "@truckdown/systems";
import { defineAsyncComponent } from 'vue';
import requests from '@truckdown/servicetransactions';

import searchForm from "./SearchForm/SearchForm.vue";
import listing from "./Listing/Listing.vue";

requests(context);

class LocationsInitializer implements IInitializer {
    name: string = 'LocationsInitializer';
    order: number = 0;

    initialize(context: IUserContext): Promise<void> {
        let app = (context as IAppUserContext).app;

        app.mixin({
            data: function () {
                return {
                    context: context,
                    constants: Constants
                }
            }
        });

        app.component('search-form', searchForm);
        app.component('listing', listing);

        app.component('location-validation-error', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-error" */ './Validation/Error/Error.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('address-form', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-address-form" */ './EditListing/ListingAddressEdit/AddressForm/AddressForm.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('services-form', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-services-form" */ './EditListing/ListingServicesEdit/ServicesForm/ServicesForm.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('networks-form', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-networks-form" */ './EditListing/ListingNetworksEdit/NetworksForm/NetworksForm.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('location-lookup', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-location-lookup" */ './LocationLookup/LocationLookup.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('address-map', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-address-map" */ './AddressMap/AddressMap.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('edit-hours', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-edit-hours" */ './EditListing/EditHours/EditHours.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('listing-menu', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-listing-menu" */ './Listing/ListingMenu/ListingMenu.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));
        app.component('rating-value', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-rating-value" */ './Listing/RatingValue/RatingValue.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));
        app.component('listing-hours', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-listing-hours" */ './Listing/ListingHours/ListingHours.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));
        app.component('listing-photos', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-listing-photos" */ './Listing/ListingPhotos/ListingPhotos.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));
        app.component('listing-map', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-listing-map" */ './Listing/ListingMap/ListingMap.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('edit-listing', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-edit-listing" */ './EditListing/EditListing.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('bulk-hours-edit', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-bulk-hours-edit" */ './EditListing/BulkHoursEdit/BulkHoursEdit.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('weekly-schedule', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-weekly-schedule" */ './EditListing/EditHours/WeeklySchedule/WeeklySchedule.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('hours-exceptions', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-hours-exceptions" */ './EditListing/EditHours/HoursExceptions/HoursExceptions.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('holiday-hours', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-holiday-hours" */ './EditListing/EditHours/HolidayHours/HolidayHours.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('hours-table-navigation', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-hours-table-navigation" */ './EditListing/EditHours/HoursTableNavigation/HoursTableNavigation.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('hours-settings', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-hours-settings" */ './EditListing/EditHours/HoursSettings/HoursSettings.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('listing-lookup', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-listing-lookup" */ './ListingLookup/ListingLookup.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('hours-status', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-hours-status" */ './HoursStatusComponent/HoursStatusComponent.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));


        app.component('signin-or-upgrade', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-signin-or-upgrade" */ './SigninOrUpgrade/SigninOrUpgrade.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('location-summary', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-location-summary" */ './LocationSummary/LocationSummary.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('banner-summary', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-banner-summary" */ './BannerSummary/BannerSummary.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('promotion', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-promotion" */ './PromotionComponent/PromotionComponent.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('request-service-button', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-request-service-button" */ './RequestServiceButton/RequestServiceButton.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('listing-template-selector-wrapper', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-listing-template-selector-wrapper" */ './EditListing/ListingTemplateSelectorWrapper/ListingTemplateSelectorWrapper.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('listing-avoid', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-listing-avoid" */ './Listing/ListingAvoid/ListingAvoid.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));
        app.component('listing-favorite', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-listing-favorite" */ './Listing/ListingFavorite/ListingFavorite.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));
        app.component('listing-forward', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-listing-forward" */ './Listing/ListingForward/ListingForward.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));
        app.component('listing-notes', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-listing-notes" */ './Listing/ListingNotes/ListingNotes.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));
        app.component('listing-rate', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-listing-rate" */ './Listing/ListingRate/ListingRate.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));
        app.component('listing-remove', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-listing-remove" */ './Listing/ListingRemove/ListingRemove.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));
        app.component('listing-upgrade', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-listing-upgrade" */ './Listing/ListingUpgrade/ListingUpgrade.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));
        app.component('listing-report-update', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-listing-report-update" */ './Listing/ListingReportUpdate/ListingReportUpdate.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));
        app.component('general-edit-modal', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-general-edit-modal" */ './EditListing/GeneralEditModal/GeneralEditModal.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));
        app.component('marketing-edit-modal', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-marketing-edit-modal" */ './EditListing/MarketingEditModal/MarketingEditModal.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));
        app.component('tagline-edit', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-tagline-edit" */ './EditListing/ListingTaglineEdit/ListingTaglineEdit.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));
        app.component('name-edit', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-name-edit" */ './EditListing/ListingNameEdit/ListingNameEdit.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));
        app.component('description-edit', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-description-edit" */ './EditListing/ListingDescriptionEdit/ListingDescriptionEdit.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));
        app.component('payment-edit', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-payment-edit" */ './EditListing/ListingPaymentEdit/ListingPaymentEdit.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));
        app.component('numbers-edit', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-numbers-edit" */ './EditListing/ListingNumbersEdit/ListingNumbersEdit.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));
        app.component('website-edit', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-website-edit" */ './EditListing/ListingWebsiteEdit/ListingWebsiteEdit.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));
        app.component('address-edit', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-address-edit" */ './EditListing/ListingAddressEdit/ListingAddressEdit.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('services-edit', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-services-edit" */ './EditListing/ListingServicesEdit/ListingServicesEdit.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));
        app.component('networks-edit', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-networks-edit" */ './EditListing/ListingNetworksEdit/ListingNetworksEdit.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));
        app.component('logo-edit', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-logo-edit" */ './EditListing/ListingLogoEdit/ListingLogoEdit.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));
        app.component('photos-edit', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-photos-edit" */ './EditListing/ListingPhotosEdit/ListingPhotosEdit.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));
        app.component('features-edit', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-features-edit" */ './EditListing/ListingFeaturesEdit/ListingFeaturesEdit.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));
        app.component('admin-info', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-admin-info" */ './Listing/AdminInfo/AdminInfo.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));
        app.component('request-service-form', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-request-service-form" */ './RequestServiceForm/RequestServiceForm.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));
        app.component('request-register-form', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-request-register-form" */ './RequestRegisterForm/RequestRegisterForm.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));
        app.component('sr-request', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-sr-request" */ './ServiceRequest/ServiceRequest.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('ratings-list', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-ratings-list" */ './Ratings/RatingsList/RatingsList.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('ratings-chart', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-ratings-chart" */ './Ratings/RatingsChart/RatingsChart.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('listing-ratings', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-listing-ratings" */ './Listing/ListingRatings/ListingRatings.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('rating-value', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-rating-value" */ './Listing/RatingValue/RatingValue.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));


        app.component('rating', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-rating" */ './Ratings/Rating/Rating.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('stars-value', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-stars-value" */ './Ratings/StarsValue/StarsValue.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('account-lookup', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-account-lookup" */ './AccountLookup/AccountLookup.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('rating-reply', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-locations-rating-reply" */ './Ratings/RatingReply/RatingReply.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        return Promise.resolve();
    }
}

context.registerService({
    name: 'IInitializer',
    activator: async () => {
        return new LocationsInitializer();
    }
});
